export const getVarieteLabel = (varietes) => {
  if (varietes.length === 1) {
    return varietes[0].label.toLowerCase();
  } else {
    return `${varietes[0].label.toLowerCase() + varietes.length - 1}`;
  }
};
